exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip .tooltip-arrow {\n  margin: 0;\n  border-color: transparent;\n}\n", ""]);

// exports
